import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-172">
      <div className="max-w-4xl mx-auto text-center" data-id="element-173">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3 drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-174">
          <span className="text-4xl" data-id="element-175">🧘‍♀️</span> EDULABS™ Yoga
        </div>

        <p className="text-white/90 text-lg leading-relaxed mb-10 max-w-xl mx-auto font-medium" data-id="element-176">
          Ressources d'excellence pour le mouvement et la sérénité.
        </p>

        <div className="flex items-center justify-center gap-6 text-sm text-white/80 mb-10" data-id="element-177">
          <span className="flex items-center gap-2" data-id="element-178">
            <span data-id="element-179">📧</span> soporte.edulabs@gmail.com
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-180" />

        <p className="text-white/60 text-xs tracking-wider" data-id="element-181">
          © EDULABS™ 2026 — Tous droits réservés.
        </p>
      </div>
    </footer>;
}